<div [ngClass]="{ Group: options.displayAssetsAndLiabilitiesInSamePage }">
    <ng-container *ngFor="let sectionTable of finTableData">
        <div [ngClass]="{ subGroup: options.displayAssetsAndLiabilitiesInSamePage }">
            <table style="width: 100%">
                <ng-container *ngFor="let row of sectionTable">
                    <ng-container *ngIf="row.rowType === 'TableHead'">
                        <thead>
                            <tr [style.color]="tableHeaderColor" class="header">
                                <th [attr.colspan]="2" class="tableTitle">{{ row.t }}</th>
                                <th
                                    class="tableTitle date-align"
                                    [ngClass]="
                                        options.printClosingValueTotalsInSeparateColumn
                                            ? 'date-align-center'
                                            : 'date-align'
                                    "
                                    [attr.colspan]="options.printClosingValueTotalsInSeparateColumn ? 2 : 1"
                                >
                                    {{ row.currentDateTitle }}
                                </th>
                                <th class="tableTitle date-align" *ngIf="!noPreviousData">
                                    {{ row.previousDateTitle }}
                                </th>
                            </tr>
                            <tr
                                [style.color]="tableHeaderColor"
                                class="big-row-min-height_plus-border-height black-border-down header"
                            >
                                <th class="account-number-column">
                                    {{ row.extraHeader1 }}
                                </th>
                                <th class="title">
                                    {{ row.extraHeader2 }}
                                </th>
                                <th
                                    class="value"
                                    [ngClass]="
                                        options.printClosingValueTotalsInSeparateColumn
                                            ? 'date-align-center'
                                            : 'date-align'
                                    "
                                    [attr.colspan]="options.printClosingValueTotalsInSeparateColumn ? 2 : 1"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cV }}
                                </th>
                                <th class="value" *ngIf="!noPreviousData" [style.background-color]="backgroundColorPY">
                                    {{ row.pV }}
                                </th>
                            </tr>
                        </thead>
                    </ng-container>

                    <ng-container *ngIf="row.rowType === 'Row'">
                        <tr
                            [ngClass]="'counter-level-' + row.level"
                            [style.color]="textColor"
                            class="row-min-height_plus-border-height fli-row"
                        >
                            <td class="account-number-column"></td>
                            <td class="title">{{ row.t }}</td>
                            <td
                                [ngClass]="options.printClosingValueTotalsInSeparateColumn ? 'value-half' : 'value'"
                                [style.background-color]="backgroundColor"
                            ></td>
                            <td
                                *ngIf="options.printClosingValueTotalsInSeparateColumn"
                                class="value-half"
                                [style.background-color]="backgroundColor"
                            ></td>
                            <td class="value" *ngIf="!noPreviousData" [style.background-color]="backgroundColorPY"></td>
                        </tr>
                    </ng-container>
                    <ng-container *ngIf="row.rowType === 'SubRow'">
                        <tr
                            [ngClass]="'counter-level-' + row.level"
                            [style.color]="textColor"
                            class="row-min-height_plus-border-height gray-border-down"
                        >
                            <td class="account-number-column">{{ row.r }}</td>
                            <td class="title">
                                <span>{{ row.t }}</span>
                            </td>
                            <td
                                *ngIf="options.printClosingValueTotalsInSeparateColumn"
                                class="value-half"
                                [style.background-color]="backgroundColor"
                            >
                                {{ row.cF }}
                            </td>
                            <td
                                [ngClass]="options.printClosingValueTotalsInSeparateColumn ? 'value-half' : 'value'"
                                [style.background-color]="backgroundColor"
                            >
                                {{ row.cV }}
                            </td>
                            <td class="value" *ngIf="!noPreviousData" [style.background-color]="backgroundColorPY">
                                {{ row.pV }}
                            </td>
                        </tr>
                    </ng-container>

                    <ng-container *ngIf="row.rowType === 'GroupTotal'">
                        <tr
                            [style.color]="tableFooterColor"
                            [ngClass]="'reset-counter-' + (row.level == undefined ? 1 : row.level)"
                            class="row-min-height_plus-border-height big-row-min-height_plus-border-height ng-star-inserted"
                        >
                            <td class="account-number-column black-border-down bolder-bigger big-row-min-height">
                                {{ row.r }}
                            </td>
                            <td class="title row-min-height black-border-down bolder-bigger big-row-min-height"></td>
                            <td
                                *ngIf="options.printClosingValueTotalsInSeparateColumn"
                                class="value-half black-border-down bolder-bigger big-row-min-height"
                                [style.background-color]="backgroundColor"
                            >
                                {{ row.cF }}
                            </td>
                            <td
                                [ngClass]="options.printClosingValueTotalsInSeparateColumn ? 'value-half' : 'value'"
                                class="black-border-down bolder-bigger big-row-min-height"
                                [style.background-color]="backgroundColor"
                            >
                                {{ row.cV }}
                            </td>

                            <td
                                class="value black-border-down bolder-bigger big-row-min-height"
                                *ngIf="!noPreviousData"
                                [style.background-color]="backgroundColorPY"
                            >
                                {{ row.pV }}
                            </td>
                        </tr>
                    </ng-container>
                    <ng-container *ngIf="row.rowType === 'TableTotal'">
                        <tr
                            [style.color]="tableFooterColor"
                            [ngClass]="'reset-counter-' + (row.level == undefined ? 1 : row.level)"
                            class="row-min-height_plus-border-height big-row-min-height_plus-border-height ng-star-inserted"
                        >
                            <td class="account-number-column black-border-down bolder-bigger big-row-min-height">
                                {{ row.r }}
                            </td>
                            <td class="title row-min-height black-border-down bolder-bigger big-row-min-height"></td>
                            <td
                                *ngIf="options.printClosingValueTotalsInSeparateColumn"
                                class="value-half black-border-down bolder-bigger big-row-min-height"
                                [style.background-color]="backgroundColor"
                            >
                                {{ row.cF }}
                            </td>
                            <td
                                [ngClass]="options.printClosingValueTotalsInSeparateColumn ? 'value-half' : 'value'"
                                class="black-border-down bolder-bigger big-row-min-height"
                                [style.background-color]="backgroundColor"
                            >
                                {{ row.cV }}
                            </td>

                            <td
                                class="value black-border-down bolder-bigger big-row-min-height"
                                *ngIf="!noPreviousData"
                                [style.background-color]="backgroundColorPY"
                            >
                                {{ row.pV }}
                            </td>
                        </tr>
                        <tr [style.color]="tableFooterColor" class="">
                            <td [attr.colspan]="colCount" class="tableTitle">&nbsp;</td>
                        </tr>
                    </ng-container>
                </ng-container>
            </table>
            <br />
        </div>
    </ng-container>
</div>
